// Module
var code = "<div class=\"hotspot hotspot-door-ground\"> <div class=\"spot-center switching\"> <div class=\"hotspot-door-ring icon\"></div> <div class=\"label\"></div> </div> </div> ";
// Exports
module.exports = code;